export const LOGOUT_CONTAINER_TAG_NAME = 'logout-container';
